import { createRequestTypes } from "../utils/createRequestTypes";

export const LOGIN_USER = createRequestTypes("LOGIN_USER");
export const LOGOUT_USER = createRequestTypes("LOGOUT_USER");
export const CLEAR_USER_DETAILS = "CLEAR_USER_DETAILS";
